<template>
  <div>
    <el-container>
      <el-main style="padding: 15px 20px 15px">
        <search-bar ref="search" @search="handleSearch" @exportCustom="exportCustom"></search-bar>
      </el-main>
    </el-container>
    <el-container>
      <el-header height="32px" style="line-height: 32px; margin-bottom: 15px" v-if="(!isReported || (isShowBackBth && isShowBackFlag)) && !isAllPlan">
        <template v-if="!isReported">
          <el-button type="primary" size="small" @click="exportExcel">导出</el-button>
        </template>
        <template v-if="!isReported">
          <el-tooltip placement="top">
            <div slot="content">由此处导入{{nextCurrentMonth}}月"{{currentMonthStr(+nextCurrentMonth)}}月预估”及<br/>{{+currentMonth}}月的“{{currentMonthStr(+currentMonth)}}月预估调整</div>
            <el-button type="primary" size="small" :disabled="isReported" @click="importFile">预估导入</el-button>
          </el-tooltip>
        </template>
        <template v-if="isShowBackBth && isShowBackFlag">
          <el-button type="primary" size="small" @click="backClick">回退</el-button>
        </template>
        <template v-if="!isReported">
          <el-button type="primary" size="small" @click="planSubmit" :disabled="!isAbleReport || isReported" v-if="!isAllPlan">提报</el-button>
          <span style="color: #999">！提报后不可再编辑修改</span>
        </template>
      </el-header>
    </el-container>
    <el-container>
      <el-main style="padding: 0 20px 10px 20px">
        <!-- form -->
        <el-form :model="rowData" :rules="rules" ref="ruleForm">
          <el-table
            border
            ref="table"
            :data="tableData"
            :height="tableHeight + 'px'"
            @sort-change="handleSortChange"
            v-loading="tableData === null"
            v-if="tableHeight"
          >
            <el-table-column label="图片" width="50px" fixed="left">
              <template slot-scope="scope">
                <el-link type="primary" :underline="false" v-if="scope.row.imgUrlList.length" @click="showDialog(scope.row, 0)">查看</el-link>
                <el-link :underline="false" disabled v-else>查看</el-link>
              </template>
            </el-table-column>
            <el-table-column label="商品编码" prop="goodsCode" width="150px" fixed="left" sortable="custom">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.goodsCode" placement="top" :open-delay="1000">
                  <span style="max-width: 100%; display: inline-block; overflow: hidden; text-overflow: ellipsis">{{ scope.row.goodsCode }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="商品名称" prop="goodsName" min-width="280px" fixed="left" sortable="custom">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.goodsName" placement="top" :open-delay="1000">
                  <span style="max-width: 100%; display: inline-block; overflow: hidden; text-overflow: ellipsis">{{ scope.row.goodsName }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column :label="`${currentMonth}月预估`" prop="subMonthPlan" width="100px" align="right" sortable="custom">
              <template #header>
                <span>{{`${currentMonth}月预估`}}</span>
                <el-tooltip class="item" effect="dark" content="即在2个月前的月初导入的预估数据；" placement="top">
                  <span class="el-icon-warning-outline"></span>
                </el-tooltip>
              </template>
            </el-table-column>

            <!-- 预估调整 显示编辑列 -->

            <!-- 全部场景：未提报+全平台 未提报+店铺 已提报+全平台 已提报+店铺 -->
            <!-- 已提报+店铺，列可以点击弹出框进行编辑 -->
            <template v-if="isReported && !isAllPlan">
              <el-table-column :label="`${currentMonth}月预估调整`" prop="subMonthAdjust" width="120px" align="right" sortable="custom">
                <template #header>
                  <span>{{`${currentMonth}月预估调整`}}</span>
                  <el-tooltip class="item" effect="dark" content="即导入的调整预估数据，始终展示最新一版数据；最终以最新一版数据作为预估调整值来当月预销分数；" placement="top">
                    <span class="el-icon-warning-outline"></span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <el-link
                    type="primary"
                    :underline="false"
                    @click="showsubMonthAdjust(scope.row, 'subMonthAdjust')"
                    v-permission="`ec-pc-new$advanceSalesManagement$preSalePlan$preSalePlan$edit adjust`"
                  >
                    {{ scope.row.subMonthAdjust || 0 }}
                  </el-link>
                  <span v-no-permission="`ec-pc-new$advanceSalesManagement$preSalePlan$preSalePlan$edit adjust`">{{ scope.row.subMonthAdjust || 0 }}</span>
                </template>
              </el-table-column>

              <el-table-column :label="`季度调整量`" prop="planAdjustMonth" width="140px" align="right" sortable="custom">
                <template #header>
                <span>季度调整量</span>
                <el-tooltip class="item" effect="dark" content="即每月15号之前导入的季度调整预估数据，始终展示最新一版数据；季度计算时，最终以季度内各月最新一版数据作为季度预估调整值汇总计算；" placement="top">
                  <span class="el-icon-warning-outline"></span>
                </el-tooltip>
              </template>
              </el-table-column>
              <el-table-column
                :label="`${parseInt(currentMonth)}月初次预估调整`"
                prop="subMonthHistoryPlanAdjust"
                width="160px"
                align="right"
                sortable="custom"
              >
              <template #header>
                <span>{{`${parseInt(currentMonth)}月初次预估调整`}}</span>
                <el-tooltip class="item" effect="dark" content="即首次导入的调整预估数据；" placement="top">
                  <span class="el-icon-warning-outline"></span>
                </el-tooltip>
              </template>
              </el-table-column>
            </template>

            <!-- 未提报+全平台 未提报+店铺 已提报+全平台 -->
            <template v-else>
              <!-- 显示弹窗列表列 -->

              <!-- 店铺已提报，全平台未提报 && 全平台 -->
              <template v-if="isAllStoresReported && isAllPlan">
                <el-table-column prop="subMonthAdjust" width="120px" align="right" sortable="custom">
                  <template #header>
                    <span>{{`${currentMonth}月预估调整`}}</span>
                    <el-tooltip class="item" effect="dark" content="即导入的调整预估数据，始终展示最新一版数据；最终以最新一版数据作为预估调整值来当月预销分数；" placement="top">
                      <span class="el-icon-warning-outline"></span>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <el-link
                      type="primary"
                      :underline="false"
                      @click="showsubMonthAdjustRecord(scope.row)"
                      v-permission="`ec-pc-new$operationAnalysis$provide&require$preSalePlan$adjustDetail`"
                    >
                      {{ scope.row.subMonthAdjust || 0 }}
                    </el-link>
                    <span v-no-permission="`ec-pc-new$operationAnalysis$provide&require$preSalePlan$adjustDetail`">{{ scope.row.subMonthAdjust || 0 }}</span>
                  </template>
                </el-table-column>

                <el-table-column :label="`${beforeTwoMonth}月实销`" prop="ringActualSales" width="100PX" align="right"></el-table-column>
                <el-table-column :label="`去年${currentMonthNumber}月实销`" prop="yoyActualSales" width="120PX" align="right"></el-table-column>
                <el-table-column label="预/实销环比" prop="ringRate" width="120PX" align="right">
                  <template #header>
                    <span>预/实销环比</span>
                    <el-tooltip class="item" content="(M月最新预估值-(M-2)月实销)/(M-2)月实销" placement="top">
                      <span class="el-icon-warning-outline"></span>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <span>{{scope.row.ringRate * 100 | formatFloat}}%</span>
                  </template>
                </el-table-column>
                <el-table-column label="预/实销同比" prop="yoyRate" width="120PX" align="right">
                  <template #header>
                    <span>预/实销同比</span>
                    <el-tooltip class="item" content="(M月最新预估值-去年M月实销)/去年M月实销" placement="top">
                      <span class="el-icon-warning-outline"></span>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <span>{{scope.row.yoyRate * 100 | formatFloat}}%</span>
                  </template>
                </el-table-column>

                <el-table-column :label="`${nextCurrentMonth}月预估`" prop="nextEstimate" width="100PX" align="right"></el-table-column>
                <el-table-column :label="`去年${nextCurrentMonth}月实销`" prop="nextYoyActualSales" width="120PX" align="right"></el-table-column>
                <el-table-column label="预/实销环比" prop="nextRingRate" width="120PX" align="right">
                  <template #header>
                    <span>预/实销环比</span>
                    <el-tooltip class="item" content="(M月最新预估值-(M-2)月实销)/(M-2)月实销" placement="top">
                      <span class="el-icon-warning-outline"></span>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <span>{{scope.row.nextRingRate * 100 | formatFloat}}%</span>
                  </template>
                </el-table-column>
                <el-table-column label="预/实销同比" prop="nextYoyRate" width="120PX" align="right">
                  <template #header>
                    <span>预/实销同比</span>
                    <el-tooltip class="item" content="(M月最新预估值-去年M月实销)/去年M月实销" placement="top">
                      <span class="el-icon-warning-outline"></span>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <span>{{scope.row.nextYoyRate * 100 | formatFloat}}%</span>
                  </template>
                </el-table-column>

                <el-table-column :label="`季度调整量`" prop="planAdjustMonth" width="140px" align="right" sortable="custom">
                  <template #header>
                    <span>季度调整量</span>
                    <el-tooltip class="item" effect="dark" content="即每月15号之前导入的季度调整预估数据，始终展示最新一版数据；季度计算时，最终以季度内各月最新一版数据作为季度预估调整值汇总计算；" placement="top">
                      <span class="el-icon-warning-outline"></span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="`${parseInt(currentMonth)}月初次预估调整`"
                  prop="subMonthHistoryPlanAdjust"
                  width="140px"
                  align="right"
                  sortable="custom"
                >
                <template #header>
                  <span>{{`${parseInt(currentMonth)}月初次预估调整`}}</span>
                  <el-tooltip class="item" effect="dark" content="即首次导入的调整预估数据；" placement="top">
                    <span class="el-icon-warning-outline"></span>
                  </el-tooltip>
                </template>
                </el-table-column>
              </template>

              <!-- 显示普通列 -->
              <template v-else>
                <el-table-column prop="subMonthAdjust" width="120px" align="right" sortable="custom">
                  <template #header>
                    <span>{{`${currentMonth}月预估调整`}}</span>
                    <el-tooltip class="item" effect="dark" content="即导入的调整预估数据，始终展示最新一版数据；最终以最新一版数据作为预估调整值来当月预销分数；" placement="top">
                      <span class="el-icon-warning-outline"></span>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item v-if="scope.row.editable" prop="subMonthAdjust">
                      <el-input v-model.trim="rowData.subMonthAdjust" size="mini" @input="handleNextMonthAdjustChange(rowData)"></el-input>
                    </el-form-item>
                    <span v-else>{{ scope.row.subMonthAdjust }}</span>
                  </template>
                </el-table-column>

                <el-table-column :label="`${beforeTwoMonth}月实销`" prop="ringActualSales" width="100PX" align="right"></el-table-column>
                <el-table-column :label="`去年${currentMonthNumber}月实销`" prop="yoyActualSales" width="120PX" align="right"></el-table-column>
                <el-table-column label="预/实销环比" prop="ringRate" width="120PX" align="right">
                  <template #header>
                    <span>预/实销环比</span>
                    <el-tooltip class="item" content="(M月最新预估值-(M-2)月实销)/(M-2)月实销" placement="top">
                      <span class="el-icon-warning-outline"></span>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <span>{{scope.row.ringRate * 100 | formatFloat}}%</span>
                  </template>
                </el-table-column>
                <el-table-column label="预/实销同比" prop="yoyRate" width="120PX" align="right">
                  <template #header>
                    <span>预/实销同比</span>
                    <el-tooltip class="item" content="(M月最新预估值-去年M月实销)/去年M月实销" placement="top">
                      <span class="el-icon-warning-outline"></span>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <span>{{scope.row.yoyRate * 100 | formatFloat}}%</span>
                  </template>
                </el-table-column>

                <el-table-column :label="`${nextCurrentMonth}月预估`" prop="nextEstimate" width="100PX" align="right"></el-table-column>
                <el-table-column :label="`去年${nextCurrentMonth}月实销`" prop="nextYoyActualSales" width="120PX" align="right"></el-table-column>
                <el-table-column label="预/实销环比" prop="nextRingRate" width="120PX" align="right">
                  <template #header>
                    <span>预/实销环比</span>
                    <el-tooltip class="item" content="(M月最新预估值-(M-2)月实销)/(M-2)月实销" placement="top">
                      <span class="el-icon-warning-outline"></span>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <span>{{scope.row.nextRingRate * 100 | formatFloat}}%</span>
                  </template>
                </el-table-column>
                <el-table-column label="预/实销同比" prop="nextYoyRate" width="120PX" align="right">
                  <template #header>
                    <span>预/实销同比</span>
                    <el-tooltip class="item" content="(M月最新预估值-去年M月实销)/去年M月实销" placement="top">
                      <span class="el-icon-warning-outline"></span>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <span>{{scope.row.nextYoyRate * 100 | formatFloat}}%</span>
                  </template>
                </el-table-column>

                <el-table-column :label="`季度调整量`" prop="planAdjustMonth" width="140px" align="right" sortable="custom">
                  <template #header>
                    <span>季度调整量</span>
                    <el-tooltip class="item" effect="dark" content="即每月15号之前导入的季度调整预估数据，始终展示最新一版数据；季度计算时，最终以季度内各月最新一版数据作为季度预估调整值汇总计算；" placement="top">
                      <span class="el-icon-warning-outline"></span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <template v-if="isReported">
                  <el-table-column
                    :label="`${parseInt(currentMonth)}月初次预估调整`"
                    prop="subMonthHistoryPlanAdjust"
                    width="140px"
                    align="right"
                    sortable="custom"
                  >
                  <template #header>
                    <span>{{`${parseInt(currentMonth)}月初次预估调整`}}</span>
                    <el-tooltip class="item" effect="dark" content="即首次导入的调整预估数据；" placement="top">
                      <span class="el-icon-warning-outline"></span>
                    </el-tooltip>
                  </template>
                  </el-table-column>
                </template>
              </template>
            </template>

            <!-- 大促预估调整 显示编辑列 -->

            <!-- 全部场景：未提报+全平台 未提报+店铺 已提报+全平台 已提报+店铺 -->
            <!-- 已提报+店铺，列可以点击弹出框进行编辑 -->
            <template v-if="isReported && !isAllPlan">
              <el-table-column
                :label="`${currentMonth}月大促预估`"
                prop="subMonthPromotion"
                width="120px"
                align="right"
                sortable="custom"
                v-if="columnsPromotion && columnsPromotion[0] && columnsPromotion[0].nodeName"
              >
                <template slot-scope="scope">
                  <el-link
                    type="primary"
                    :underline="false"
                    @click="showsubMonthAdjust(scope.row, 'subMonthPromotion')"
                    v-permission="`ec-pc-new$advanceSalesManagement$preSalePlan$preSalePlan$edit adjust`"
                  >
                    {{ scope.row.subMonthPromotion || 0 }}
                  </el-link>
                  <span v-no-permission="`ec-pc-new$advanceSalesManagement$preSalePlan$preSalePlan$edit adjust`">{{ scope.row.subMonthPromotion || 0 }}</span>
                </template>
              </el-table-column>
            </template>

            <!-- 显示普通列 -->

            <!-- 满足场景：未提报+全平台 未提报+店铺 已提报+全平台 -->
            <template v-else>
              <el-table-column
                :label="`${currentMonth}月大促预估`"
                prop="subMonthPromotion"
                width="120px"
                align="right"
                sortable="custom"
                v-if="columnsPromotion && columnsPromotion[0] && columnsPromotion[0].nodeName"
              >
                <template slot-scope="scope">
                  <el-form-item v-if="scope.row.editable" prop="subMonthPromotion">
                    <el-input v-model.trim="rowData.subMonthPromotion" size="mini"></el-input>
                  </el-form-item>
                  <span v-else>{{ scope.row.subMonthPromotion }}</span>
                </template>
              </el-table-column>
            </template>

            <el-table-column label="调整量" prop="subMonthDiffAmount" width="100px" align="right" sortable="custom">
              <template #header>
                <span>调整量</span>
                <el-tooltip class="item" effect="dark" content="预估调整 - 初次预估调整" placement="top">
                  <span class="el-icon-warning-outline"></span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span>{{ scope.row.subMonthDiffAmount }}</span>
              </template>
            </el-table-column>

            <!-- 历史月份不展示N+1、N+2预估数据 -->
            <template v-if="!isReported">
              <el-table-column :label="`${nextCurrentMonth}月预估`" prop="subMonthNextPlan" width="100px" align="right" sortable="custom">
                <template #header>
                  <span>{{`${nextCurrentMonth}月预估`}}</span>
                  <el-tooltip class="item" effect="dark" content="即在2个月前的月初导入的预估数据；" placement="top">
                    <span class="el-icon-warning-outline"></span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <el-form-item v-if="scope.row.editable" prop="subMonthNextPlan">
                    <el-input v-model.trim="rowData.subMonthNextPlan" size="mini"></el-input>
                  </el-form-item>
                  <span v-else>{{ scope.row.subMonthNextPlan }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="`${nextCurrentMonth}月大促预估`"
                prop="subMonthNextPromotion"
                width="120px"
                align="right"
                sortable="custom"
                v-if="columnsPromotion && columnsPromotion[1] && columnsPromotion[1].nodeName"
              >
                <template slot-scope="scope">
                  <el-form-item v-if="scope.row.editable" prop="subMonthNextPromotion">
                    <el-input v-model.trim="rowData.subMonthNextPromotion" size="mini"></el-input>
                  </el-form-item>
                  <span v-else>{{ scope.row.subMonthNextPromotion }}</span>
                </template>
              </el-table-column>
            </template>

            <!-- 未提报月份&不是全平台 显示操作栏 -->
            <el-table-column label="操作" width="130PX" align="right" fixed="right" sortable="custom" v-if="!isReported && !isAllPlan">
              <template slot-scope="scope" v-if="!isReported">
                <el-button type="text" @click="rowModify(scope.row)" v-if="!scope.row.editable">编辑</el-button>
                <template v-else>
                  <el-button type="text" @click="updateRow(rowData)">保存</el-button>
                  <el-button type="text" @click="cancel">取消</el-button>
                </template>
                <el-button type="text" @click="historySale(scope.row)">历史销量</el-button>
              </template>
            </el-table-column>
            <!-- 已提报月份显示其他数据列 -->
            <template v-if="isReported">
              <el-table-column label="直播销量" prop="planLiveSalesResult" width="120PX" align="right" sortable="custom"></el-table-column>
              <el-table-column label="实际销量" prop="salesResult" sortable="custom" width="120PX" align="right">
                <template slot-scope="scope">
                  <span v-if="isAllPlan">
                    <el-link type="primary" :underline="false" @click="showSalesResult(scope.row)">{{ scope.row.salesResult }}</el-link>
                  </span>
                  <span v-else>{{ scope.row.salesResult }}</span>
                </template>
              </el-table-column>
              <el-table-column label="截止3日销量（不含直播）" prop="endSalesResult" width="160PX" align="right" sortable="custom">
                <template #header>
                  <span>截止3日销量</span>
                  <el-tooltip class="item" effect="dark" content="（不含直播）" placement="top">
                    <span class="el-icon-warning-outline"></span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column label="当前应售" prop="finalPlanAmount" width="120PX" align="right" sortable="custom"></el-table-column>
              <el-table-column :label="`${beforeTwoMonth}月实销`" prop="ringActualSales" width="100PX" align="right" sortable="custom"></el-table-column>
              <el-table-column label="预/实销环比" prop="ringRate" width="120PX" align="right" sortable="custom">
                <template #header>
                  <span>预/实销环比</span>
                  <el-tooltip class="item" content="(M月最新预估值-(M-2)月实销)/(M-2)月实销" placement="top">
                    <span class="el-icon-warning-outline"></span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <span>{{scope.row.ringRate * 100 | formatFloat}}%</span>
                </template>
              </el-table-column>
            <el-table-column :label="`去年${currentMonthNumber}月实销`" prop="yoyActualSales" width="120PX" align="right" sortable="custom"></el-table-column>
              <el-table-column label="预/实销同比" prop="yoyRate" width="120PX" align="right" sortable="custom">
                <template #header>
                  <span>预/实销同比</span>
                  <el-tooltip class="item" content="(M月最新预估值-去年M月实销)/去年M月实销" placement="top">
                    <span class="el-icon-warning-outline"></span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <span>{{scope.row.yoyRate * 100 | formatFloat}}%</span>
                </template>
              </el-table-column>
              <el-table-column label="预估差额" prop="diffAmount" width="120PX" align="right" sortable="custom"></el-table-column>
              <el-table-column label="预估差异率" prop="diffRate" width="120PX" align="right" sortable="custom">
                <template #header>
                  <span>预估差异率</span>
                  <el-tooltip class="item" effect="dark" content="（实际销量-当前应售）/当前应售" placement="top">
                    <span class="el-icon-warning-outline"></span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <el-link type="danger" :underline="false" v-if="scope.row.diffRate > 0.2 || scope.row.diffRate < -0.2"
                    >{{ (scope.row.diffRate * 100) | formatFloat }}%</el-link
                  >
                  <span v-else>{{ (scope.row.diffRate * 100) | formatFloat }}%</span>
                </template>
              </el-table-column>
              <el-table-column label="预估情况" prop="status" width="120PX" align="right" sortable="custom"></el-table-column>
            </template>
          </el-table>
        </el-form>

        <!-- pagination -->
        <div style="overflow: hidden">
          <div style="float: left; margin-top: 15px; color: #555">
            <span>{{ dataUpdateObj.updateContent }}：</span>
            <span>{{ dataUpdateObj.latestUpdateTime }}</span>
          </div>
          <el-pagination
            style="float: right; margin-top: 10px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total"
          >
          </el-pagination>
        </div>

        <!-- dialog -->
        <v-dialog v-model="historyVisible" :config="dialogConfig" @dialogConfirm="dialogConfirm">
          <div slot="content">
            <history-sale :data="{ ...rowData, ...form, ...formData }" v-if="dialogType === 'history' && historyVisible"></history-sale>
          </div>
        </v-dialog>

        <!-- 图片&视频 -->
        <pic-video :data="rowData" :detailType="viewType" ref="picVideo"></pic-video>

        <!-- 实际销量 -->
        <sales-result v-model="salesResultVisible" :data="rowData" v-if="salesResultVisible"></sales-result>

        <!-- 编辑预估调整量 -->
        <sub-month-adjust v-model="subMonthAdjustVisible" :data="rowData" v-if="subMonthAdjustVisible"></sub-month-adjust>

        <!-- 预估调整弹窗列表 -->
        <sub-month-adjust-record v-model="subMonthAdjustRecordVisible" :data="rowData" v-if="subMonthAdjustRecordVisible"></sub-month-adjust-record>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import mixin from '@/views/preSalePlan/utils/mixin.js';
import picVideoMixin from './pic&video.mixin';
import salesResultMixin from './salesResult.mixin';
import subMonthAdjustMixin from './subMonthAdjust.mixin';
import subMonthAdjustRecordMixin from './subMonthAdjustRecord.mixin';
import pagePathMixin from '@/utils/page-path-mixin'

import moment from 'moment';

import searchBar from './components/searchBar/searchBar';
import saleSelect from '@/views/preSalePlan/common/saleSelect';

import historySale from './components/history-sale/history-sale';

import * as Global from '@/utils/Global.js';
import { isInt } from '@/utils/validate.js';

export default {
  mixins: [mixin, picVideoMixin, salesResultMixin, subMonthAdjustMixin, subMonthAdjustRecordMixin, pagePathMixin],
  components: { searchBar, saleSelect, historySale },
  props: ['form', 'dataUpdateObj', 'cachedComponents'],
  data() {
    const numberValid = (rule, value, callback) => {
      if (value == '' || value == 0) {
        callback();
        return;
      }
      let status = isInt(value);
      if (status) {
        callback();
      } else {
        callback(new Error('必须是数字'));
      }
    };
    return {
      formData: {},
      columnsPromotion: null,
      tableData: null,
      tableHeight: 0,
      paginationOpt: {
        pageSizes: [30, 60, 90, 500],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      // dialog
      dialogType: '',
      rowData: null,
      // 历史销量
      historyVisible: false,
      isShowBackFlag: false,
      dialogConfig: {},
      rules: {
        subMonthAdjust: [{ validator: numberValid, trigger: 'change' }],
        subMonthPromotion: [{ validator: numberValid, trigger: 'change' }],
        subMonthNextPlan: [{ validator: numberValid, trigger: 'change' }],
        subMonthNextPromotion: [{ validator: numberValid, trigger: 'change' }],
      },
      // table 升序降序
      descOrAsc: '',
      fieldName: '',
    };
  },
  computed: {
    reportName() {
      return this.isReported ? 'preSalePlanGoods' : 'preSalePlanGoodsOfUnsub';
    },
    // 当前所在月份
    currentMonth() {
      return this.form.planTime.split('-')[1];
    },
    currentMonthNumber() {
      return Number(this.currentMonth);
    },
    // 当前所在月份的下一个月
    nextCurrentMonth() {
      return +this.currentMonth + 1 == 13 ? 1 : +this.currentMonth + 1
    },
    beforeTwoMonth() {
      let date = new Date(`${this.form.planTime}-01`)
      date.setMonth(date.getMonth() - 2)
      return date.getMonth() + 1
    },
    // 是否可以提报
    isAbleReport() {
      if (this.isReported) return false;

      let tableData = this.tableData;
      if (!tableData || !tableData.length) return false;

      // 每一行的下列四个字段，至少要有一列的一个值不为空。
      let validRow = tableData.filter((v) => {
        let num = v['subMonthAdjust'] + v['subMonthPromotion'] + v['subMonthNextPlan'] + v['subMonthNextPromotion'];
        v['summary'] = num;
        return num !== '';
      });
      if (validRow.length === 0) {
        return false;
      } else {
        return true;
      }

      // 不为空的数据行，当值大于0时，必须选择销售定位
      // validRow = validRow.filter(v=>v['summary'] > 0);
      // if(validRow.length === 0) return true;

      // let has_SaleLocation = validRow.filter(v=>v['saleLocation']);
      // return has_SaleLocation.length === validRow.length && true || false
    },
    isShowBackBth() {
      let buttonJurisdiction = JSON.parse(localStorage.getItem('permitList')); //列展示权限获取
      let Jurisdiction = 'ec-pc-new$operationAnalysis$provide&require$preSalePlan$skuBth';
      return buttonJurisdiction.includes(Jurisdiction);
    },
  },
  mounted() {
    this.getColumns_promotion();
    this.addListener_refresh();
    setTimeout(() => {
      this.init();
      if(!this.isAllPlan){
        this.planRollBackGetShowFlag()
      }
    }, 300);
  },
  methods: {
    // 大促活动信息
    async getColumns_promotion() {
      let params = {
        planTime: this.form.planTime,
      };
      let res = await this.$q.preSalePlan.predictionNodeGet({ params });
      if (res.success && res.data && res.data.length) {
        this.columnsPromotion = res.data;
      } else {
        this.columnsPromotion = [];
      }
    },
    handleSearch(data, type) {
      if (type == 1) {
        this.descOrAsc = '';
        this.fieldName = '';
        this.$refs.table.clearSort();
      }
      this.formData = data;
      // 重置分页
      this.paginationOpt['pageNum'] = 1;
      this.init();
    },
    addListener_refresh() {
      this.$bus.$off('refresh');
      this.$bus.$on('refresh', (_) => {
        this.tableHeight = 0;
        this.$nextTick((_) => {
          // 重置搜索条件
          this.formData = {};
          if (this.$refs['search']) {
            this.$refs['search'].form = {};
          }
          // this.$refs['search'].form = {};
          // this.formData = { saleLocation: ''};
          // this.$refs['search'].form = { saleLocation: ''};
          // 重置分页
          this.paginationOpt['pageNum'] = 1;
          this.paginationOpt['pageSize'] = 30;
          this.getColumns_promotion();
          if(!this.isAllPlan){
            this.planRollBackGetShowFlag()
          }
          this.init();
        });
      });
    },
    getGoodsFilterData() {
      const filterData = {
        ...this.form,
        ...this.formData
      };
      return {
        descOrAsc: this.descOrAsc || '',
        fieldName: this.fieldName || '',
        goodsCode: filterData.goodsCode || '',
        goodsName: filterData.goodsName || '',
        planTime: filterData.planTime || '',
        queryAbnormalGoodsFlag: filterData.queryAbnormalGoodsFlag || '',
        saleLocation: filterData.saleLocation || '',
        status: filterData.status || '',
        storeId: filterData.storeId === undefined || filterData.storeId === null ? '' : filterData.storeId
      };
    },
    async init() {
      this.tableHeight = document.documentElement.clientHeight - ((!this.isReported || (this.isShowBackBth && this.isShowBackFlag)) && !this.isAllPlan ? 370 : 325);
      this.tableData = null;
      let data = {
        pageNum: this.paginationOpt.pageNum,
        pageSize: this.paginationOpt.pageSize,
        filterData: this.getGoodsFilterData(),
      };
      let res;
      if (!this.isReported) {
        // 未提报
        res = await this.$q.preSalePlan.goodsUnsubListPage({ data });
      } else {
        // 已提报
        res = await this.$q.preSalePlan.goodsResultListPage({ data });
      }
      if (res && res.success && res.data) {
        this.tableData = res.data.records;
        this.paginationOpt.total = res.data.total;
      } else {
        this.tableData = [];
        this.paginationOpt.total = 0;
      }
    },
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
    // row 编辑
    rowModify(row) {
      this.tableData.forEach((item) => this.$set(item, 'editable', false));
      this.rowData = row;
      this.$set(row, 'editable', true);
    },
    cancel(row) {
      this.$set(row, 'editable', false);
      this.init();
    },
    // row 保存
    updateRow(row) {
      this.$refs['ruleForm'].validate(async (valid) => {
        if (valid) {
          // let index = [row['subMonthAdjust'], row['subMonthPromotion'], row['subMonthNextPlan'], row['subMonthNextPromotion']].findIndex(v=>v>0)
          // if(index > -1 && !row['saleLocation']) {
          //   this.$message('请选择销售定位');
          //   return;
          // }
          let data = {
            goodsCode: row.goodsCode,
            // saleLocation: row.saleLocation,
            planTime: this.form.planTime,
            storeId: this.form.storeId,
            subMonthAdjust: row.subMonthAdjust,
            subMonthNextPlan: row.subMonthNextPlan,
            subMonthNextPromotion: row.subMonthNextPromotion,
            subMonthPromotion: row.subMonthPromotion,
          };
          let res = await this.$q.preSalePlan.goodsUnsubModify({ data });
          if (res.success) {
            this.$message.success('修改成功');
          } else {
            this.$message.error(res.message);
          }
          this.init();
          this.$set(row, 'editable', false);
        } else {
          this.$message('请填写预估量');
        }
      });
    },
    // 历史销量
    historySale(row) {
      this.dialogType = 'history';
      this.rowData = row;
      this.dialogConfig = {
        title: '历史销量',
        showButton: false,
      };
      this.historyVisible = true;
    },
    dialogConfirm() {},
    async backClick() {
      let status = await this.$confirm('是否确认回退？', '提示', {
        type: 'warning',
      });
      if (status !== 'confirm') return;
      let data = {
        ...this.form,
      };
      this.$q.preSalePlan.planRollBack({ data: data }).then((res) => {
        if (res.success) {
          this.$message.success('回退成功');
          this.init();
          // this.$bus.$emit("monthRefresh", "");
          // this.$emit("update:cachedComponents", []);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    planRollBackGetShowFlag() {
      let data = {
        ...this.form,
      };
      this.$q.preSalePlan.planRollBackGetShowFlag({ data: data }).then((res) => {
        this.isShowBackFlag = res.data == 'Y'
        this.tableHeight = document.documentElement.clientHeight - ((!this.isReported || (this.isShowBackBth && this.isShowBackFlag)) && !this.isAllPlan ? 370 : 325);
      });
    },
    // 导入
    importFile() {
      this.openSubPage({
        path: '/commodityImport',
        query: {
          // fileType: Global.FILE_TYPE['预销计划商品信息'],
          fileName: '预销计划商品信息.xlsx',
          storeId: this.form.storeId, //2021年4月16日09:42:51
          planTime: this.planTime, //2021年4月16日09:42:51
          appCode: 'ec-pc-new',
          reportName: 'preSalePlanGoodsDataImport'
        },
      });
    },
    //导出
    exportExcel() {
      this.exportGoods();
    },
    async planSubmit() {
      let _this = this;
      const loading = this.$loading({
        lock: true,
        text: '数据正在导入中',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)',
      });
      let data = {
        storeId: this.form.storeId,
        subTime: this.planTime,
      };
      this.$q.preSalePlan
        .planSubmit({ data: data })
        .then((res) => {
          if (res.success) {
            var timer = setInterval(function () {
              _this.$q.preSalePlan
                .getShopIsSubmit({ params: { storeId: data.storeId, planTime: data.subTime } })
                .then((res) => {
                  if (res.data == true) {
                    _this.$message.success('提报成功');
                    _this.init();
                    _this.$bus.$emit('monthRefresh', '');
                    _this.$emit('update:cachedComponents', []);
                    loading.close();
                    clearInterval(timer);
                  }
                })
                .catch((err) => {
                  //this.$message(err.message)
                });
            }, 5000);
          } else {
            this.$message.fail(res.message);
          }
        })
        .finally((_) => {});
    },
    // 预估调整 input change
    handleNextMonthAdjustChange(row) {
      let adjust = (row.subMonthAdjust && row.subMonthAdjust - row.subMonthPlan) || '';
      row.subMonthDiffAmount = adjust;
    },
    handleSortChange({ column, prop, order }) {
      this.paginationOpt.pageNum = 1;
      if (order === null) {
        this.descOrAsc = '';
        this.fieldName = '';
      }
      if (order === 'ascending') {
        this.descOrAsc = '';
        this.fieldName = prop;
      }
      if (order === 'descending') {
        this.descOrAsc = 'desc';
        this.fieldName = prop;
      }
      this.init();
    },
    // 导出 --新接口
    exportCustom() {
      this.exportGoods();
    },
    async exportGoods() {
      try {
        const res = await this.$q.preSalePlan.goodsExport({
          data: {
            exportTag: true,
            pageNum: 1,
            pageSize: 99999,
            filterData: this.getGoodsFilterData(),
          },
        });
        if (!res || !res.success || !res.data) {
          this.$message.error(res && res.message ? res.message : '导出失败');
          return;
        }
      } catch (error) {
        this.$message.error('导出失败');
      }
    },
    currentMonthStr(num) {
      return num == 12 ? num : `0${num}`
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-form-item
  margin-bottom 0
</style>
